// Global focus trap functions
function trapFocus(container, elementToFocus = container) {
  var focusableEls = container.querySelectorAll(
    'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
  );
  var firstFocusableEl = focusableEls[0];
  var lastFocusableEl = focusableEls[focusableEls.length - 1];
  var KEYCODE_TAB = 9;

  if (elementToFocus && elementToFocus !== container) {
    elementToFocus.focus();
  } else {
    firstFocusableEl.focus();
  }

  function keydownListener(e) {
    var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus(); // add focus for the last focusable element
        e.preventDefault();
      }
    } else {
      // if tab key is pressed
      if (document.activeElement === lastFocusableEl) {
        // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableEl.focus(); // add focus for the first focusable element
        e.preventDefault();
      }
    }
  }

  container.addEventListener('keydown', keydownListener);
  container.keydownListener = keydownListener; // Store reference for removal
}

function removeTrapFocus(elementToFocus) {
  const containers = document.querySelectorAll('[tabindex="-1"]');
  containers.forEach(container => {
    if (container.keydownListener) {
      container.removeEventListener('keydown', container.keydownListener);
      delete container.keydownListener;
    }
  });

  if (elementToFocus) elementToFocus.focus();
}

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    
    // More specific selector for close button
    const closeButton = this.querySelector('button[type="button"].modal__close-button') || 
                       this.querySelector('.search-modal__close-button') || 
                       this.querySelector('button[type="button"]');
    
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // Find the container and input element for focus trapping
    const container = this.detailsContainer.querySelector('[tabindex="-1"]');
    const inputElement = this.detailsContainer.querySelector('input:not([type="hidden"])');
    
    if (container) {
      trapFocus(container, inputElement);
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);